module.exports = __webpack_public_path__ + "static/media/12.ca6aaa2f.png";